// @ts-nocheck
import React from 'react'
import { colors } from '@lmc/common/constants'
import { hexToRgbA } from '../../../../common/utils'
import { ProfileBadge, SectionHeader } from '../../../generic'

interface EmarMedicationTitleProps {
  fields: {
    controlledDrug: boolean
    PRN: boolean
  }
  medicationName: string | undefined
  testId?: string
  // Add other props as needed
}

const EmarMedicationTitle: React.FC<EmarMedicationTitleProps> = (props) => {
  const {
    fields: { controlledDrug, PRN },
    medicationName,
    testId
  } = props

  if (!medicationName) return null

  return (
    <div
      style={styles.medicationTitleContainer}
      data-testid={testId ? `${testId}-medication-title` : 'medication-title'}
    >
      <SectionHeader title={medicationName} titleStyles={styles.title}>
        <div
          style={styles.badgeContainer}
          data-testid={
            testId ? `${testId}-medication-badges` : 'medication-badges'
          }
        >
          {controlledDrug && (
            <ProfileBadge
              backgroundColor={hexToRgbA(colors.red, 0.2)}
              badgeStyle={styles.badge}
              badgeText="CD"
              textColor={colors.red}
            />
          )}
          {PRN && (
            <ProfileBadge
              backgroundColor={hexToRgbA(colors.blue, 0.2)}
              badgeStyle={styles.badge}
              badgeText="PRN"
              textColor={colors.blue}
            />
          )}
        </div>
      </SectionHeader>
    </div>
  )
}

const styles = {
  badge: {
    fontSize: 12,
    fontWeight: 'bold',
    marginLeft: 8,
    padding: '4px',
    borderRadius: 15
  },
  badgeContainer: {
    display: 'flex'
  },
  medicationTitleContainer: {
    marginTop: 25,
    width: '100%'
  },
  title: {
    fontSize: 28,
    lineHeight: '36px',
    marginBottom: 1,
    maxWidth: 850,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}

export default EmarMedicationTitle
